import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper } from "@material-ui/core";
import {
  renderDateTextField2,
  renderMultiLineTextField,
  renderSelectField4,
} from "../../form-global-components/components-form-components-for-react-final-form";
/*
const ADD_REFERRAL_OUTCOME_LIST = [
  { value: '1', label: 'Accepted and Pending Arrival' },
  { value: '2', label: 'On Hold' }
];
const REFERRAL_OUTCOME_LIST = [
  { value: '1', label: 'Accepted and Pending Arrival' },
  { value: '2', label: 'On Hold' },
  { value: '3', label: 'Accepted Client' },
  { value: '4', label: 'Cancelled / Withdrawn' },
  { value: '5', label: 'No Show for Admission' },
  { value: '6', label: 'Denied' }
];
*/
class FormFieldsTabOutcome extends Component {
  render() {
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    required
                    locked={this.props.locked}
                    component={renderSelectField4}
                    id="referraloutcome"
                    name="referraloutcome"
                    label="Referral Outcome"
                    footerMessage=""
                  >
                    <option value="1">Accepted and Pending Arrival</option>
                    <option value="2">On Hold</option>

                    {this.props.showReferralOutcome !== 0 ? (<option value="3">Accepted Client</option>) : null}
                    {this.props.showReferralOutcome !== 0 ? (<option value="4">Cancelled / Withdrawn</option>) : null}
                    {this.props.showReferralOutcome !== 0 ? (<option value="5">No Show for Admission</option>) : null}
                    {this.props.showReferralOutcome !== 0 ? (<option value="6">Denied</option>) : null}

                  </Field>
                </Grid>
              </Grid>

              <br />
              <hr />
              <br />
              {
                this.props._reduxForm.values.referraloutcome === "4" ||
                this.props._reduxForm.values.referraloutcome === "5" ||
                this.props._reduxForm.values.referraloutcome === "6" 
              ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="referraldeniedadmissiondate"
                      name="referraldeniedadmissiondate"
                      label="Referral Denied Admission Date"
                    />
                  </Grid>
                </Grid>
              ) : null}

              {this.props._reduxForm.values.referraloutcome === "3" ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="referralapprovedadmissiondate"
                      name="referralapprovedadmissiondate"
                      label="Referral Approved Admission Date (Client Approved Admission Date)"
                    />
                  </Grid>
                </Grid>
              ) : null}

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id="referraloutcomecomments"
                    name="referraloutcomecomments"
                    label="Referral Outcome Comments"
                    rows="6"
                    emptyText="Your comments should be clear and concise."
                    footerMessage="Your comments should be clear and concise."
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabOutcome.propTypes = {
  locked: PropTypes.bool,
  showReferralOutcome: PropTypes.number,
};
export default FormFieldsTabOutcome;
